import { type RefObject, useEffect } from 'react';

import { useErrorContext } from '@wf/sw-ui-kit';

import useScrollIntoView from '../../../hooks/useScrollIntoView';

interface IUseArrayFieldError {
  tabIndex: number;
  element: RefObject<HTMLDivElement | null>;
  index: number | null;
  setIndex: (index: number) => void;
}

function useArrayFieldError({ tabIndex, element, index, setIndex }: IUseArrayFieldError) {
  const { selectedError } = useErrorContext();

  const isFieldSelected = selectedError?.tabIndex === tabIndex && selectedError?.index === index;

  useScrollIntoView({ element, condition: isFieldSelected });

  useEffect(() => {
    if (isFieldSelected) {
      setIndex(selectedError.index as number);
    }
  }, [isFieldSelected, selectedError, setIndex]);
}

export default useArrayFieldError;
